import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../pages/Login.css';

// Get API URL from environment variables
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post(`${API_BASE_URL}/api/users/forgot-password`, { email });
      setMessage(response.data.message);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Forgot password error:", err);
      }
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login">
      <h1>Reset Password</h1>
      
      {error && <p className="error">{error}</p>}
      {message && <p className="success-message">{message}</p>}
      
      {!message ? (
        <>
          <p className="reset-instructions">
            Enter your email address and we'll send you a link to reset your password.
          </p>
          
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
            />
            
            <button type="submit" disabled={isLoading} className={isLoading ? "loading" : ""}>
              {isLoading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>
          
          <div className="back-to-login">
            <Link to="/login">Back to Login</Link>
          </div>
        </>
      ) : (
        <div className="back-to-login">
          <Link to="/login">Back to Login</Link>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;